import * as Yup from "yup";
import { runTextPipeline } from "../../utils/contentSafety";
import { useSelector } from 'react-redux';

export const defaultValues = {
  // selectedType: "",
  postType: "",
  mainCategory: "",
  subCategory: "",
  customSubcategory: "",
  postTitle: "",
  postTags: [], // Ensure postTags is initialized as an empty array
  description: "",
  range: 5,
  location: "",
  portfolioImages: [],
};

export const validationSchema = Yup.object({
  postType: Yup.string()
    .oneOf(['regular', 'featured', 'premium'], 'Please select a valid post type')
    .required("Post type is required"),
  mainCategory: Yup.object().required("Primary category is required"),
  subCategory: Yup.object().required("Sub category is required"),
  customSubcategory: Yup.string().when('subCategory', {
    is: (value) => value?.id === 'custom',
    then: () => Yup.string()
      .required('Custom subcategory is required')
      .test('contentSafety', function (value) {
        if (!value || !String(value).trim()) return true;
        const result = runTextPipeline(value, 'customSubcategory');
        if (result.valid) return true;
        return this.createError({ message: result.message });
      }),
    otherwise: () => Yup.string(),
  }),
  postTitle: Yup.string()
    .required("Title is required")
    .test('contentSafety', function (value) {
      if (!value || !String(value).trim()) return true;
      const result = runTextPipeline(value, 'post');
      if (result.valid) return true;
      return this.createError({ message: result.message });
    })
    .min(10, "Title must be at least 10 characters")
    .max(80, "Title must not exceed 80 characters"),
  postTags: Yup.array()
    .min(1, "Minimum 1 tag is required")
    .test('tagLimit', 'Tag limit exceeded for your plan', function(value) {
      const userPlan = this.parent.userPlan?.plan?.name?.toLowerCase() || 'basic';
      const maxTags = userPlan === 'pro' ? 12 : 5;
      if (value.length > maxTags) {
        return this.createError({
          message: `Maximum ${maxTags} tags allowed for ${userPlan} plan`
        });
      }
      return true;
    })
    .required("Minimum 1 tag is required"),
  portfolioImages: Yup.array().required("Please upload post images."),
  description: Yup.string()
    .required("Description is required")
    .test('contentSafety', function (value) {
      if (!value || !String(value).trim()) return true;
      const result = runTextPipeline(value, 'description');
      if (result.valid) return true;
      return this.createError({ message: result.message });
    })
    .min(50, "Description must be at least 50 characters")
    .max(500, "Description must not exceed 500 characters"),
  range: Yup.number()
    .min(1, "Range must be at least 1km")
    .max(10, "Range must not exceed 10km")
    .required("Please define radius."),
  location: Yup.string().required("Please share your location."),
});
